import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ProfileContent from '../../../components/comment/profile/profileContent';
import WalletBalance from '../walletbalance/walletBalance';

const creditsContent = () => {
  return (
    <div className="main-account credits-balance-wrap">
    <Container className="main-account-content ">
      <Row className="main-content pt-4 pb-5">
        <Col lg={3} className="content-left">
          <ProfileContent />
        </Col>

        <Col lg={9} className="content-right  " >
          <div className='verification-wrap'>
          <WalletBalance />
          
         </div>
        </Col>
      </Row>
    </Container>
  </div>
  )
}

export default creditsContent